/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getProductsList: (params, paginationParams, signal) => {
    return axios.get(API_ENDPOINTS.PRODUCTS_LIST, {
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...params, ...paginationParams },
      signal
    })
  },
  getProductById: (id) => {
    return axios.get(API_ENDPOINTS.GET_PRODUCT, {
      headers: {
        'Content-Type': 'application/json',
        path: { id },
      },
    })
  },
  getMainCategory: () => {
    return axios.get(API_ENDPOINTS.GET_MAIN_CATEGORY, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getSubCategory: (id) => {
    return axios.get(API_ENDPOINTS.GET_SUB_CATEGORY, {
      headers: {
        'Content-Type': 'application/json',
        path: { id },
      },
    })
  },
  getProductStyle: (id) => {
    return axios.get(API_ENDPOINTS.GET_PRODUCT_STYLE, {
      headers: {
        'Content-Type': 'application/json',
        path: { id },
      },
    })
  },
  getOcassionList: () => {
    return axios.get(API_ENDPOINTS.GET_OCASSION_LIST, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getPurityList: () => {
    return axios.get(API_ENDPOINTS.GET_PURITY_LIST, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getWeightRangeList: () => {
    return axios.get(API_ENDPOINTS.GET_WEIGHT_RANGE_LIST, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getGenderList: () => {
    return axios.get(API_ENDPOINTS.GET_GENDER_LIST, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  getWastageList: () => {
    return axios.get(API_ENDPOINTS.GET_WASTAGE_LIST, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  searchOptions: (params) => {
    return axios.get(API_ENDPOINTS.SEARCH_OPTIONS, {
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...params },
    })
  },
  searchProducts: (params, paginationParams) => {
    return axios.get(API_ENDPOINTS.SEARCH_PRODUCTS, {
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...params, ...paginationParams },
    })
  },
}
